<template>
    <b-container>

         <PortalNavbar show="true"></PortalNavbar>
         
<section class="function_area row" style="margin-left:40px;">
        <div class="container">
            <!--<div class="tittle wow fadeInUp">
                <h2>FUNCTIONS</h2>
               
            </div>-->
            
            <div class="row function_row">
               
                <div>
                    <div class="subtittle">
                        <h2 style="color:#ec5624;">FUNCTIONS OF THE BOARD</h2>
                    </div>

<div class="col-md-12">
<ul>
<li>The Board may take such measures as it may consider desirable for carrying out the objective of administering the Scheme set out in clause 2 including measure for.</li>
<li>Ensuring the adequate supply and the full and proper utilization of registered Security Guards of the Board for the purpose of facilitating and doing security work or watch and ward work in any factory or establishment.</li>
<li>Determining and keeping under review the number of registered Security Guards of the Board from time to time, on the registers or records and the increase or reduction to be made in the number of registered Security Guards of the Board.</li>
<li>Keeping, adjusting and maintaining the registered principal employers, registers, entering there in the name of any registered principal employer in accordance with the provisions of this Scheme.</li>
<li>Keeping, adjusting and maintaining from time to time, such registers or records as may be necessary of registered Security Guards of the Board including any registers, or records of registered Security Guards of the Board who are temporarily not available for work and whose absence has been approved by the Board; And where circumstances so require, removing from any registered or record the name of any registered Security guard of the Board either at his own request or in accordance with the provisions of the Scheme.</li>
<li>Grouping or re-grouping of all registered Security Guards of the board into such group as may be determined by the Board and reviewing the grouping of any registered Security Guards of the Board on the application of a registered Security Guard of the Board.</li>
<li>Making provision, subject to availability of funds, for welfare of registered Security Guards of the Board including medical services in so far as such provision does not exists apart from this Scheme.</li>
<li>Recovering from registered principal employers contribution in respect of the expenses of this Scheme, wages levy and other contributions under this Scheme; viii) disbursing of wages and other allowances to registered Security Guards of the Board.</li>
<li>Making provision subject to availability of funds for the health and safety measures in places where Security Guards of the Board are employed in so far as such provision does not exist apart from this Scheme.</li>
<li>Maintaining and administering the Security Guards of the Board welfare fund recovering from all the registered principal employers contribution towards the fund when such fund is constituted in accordance with the rules of the fund.</li>
<li>Maintaining and administering provident fund and gratuity fund for registered Security Guards of the Board in the Board pool when such funds are constituted.</li>
<li>Sanctioning the creation of posts, the maximum salary of which exclusive of allowances is below  5,500 per month and to make appointment to such post.</li>
<li>The property, fund and other assets vesting in the Board shall be held and applied by it subject to the provisions and for the purposes of this Scheme.</li>
<li>The Board shall have and maintain its own fund to which shall be credited.</li>
<li>All monies received by the Board from the State Government.</li>
<li>All fees, wages and levis received by the Board under this Scheme.</li>
<li>All monies received by the Board by way of sale and disposal of properties and other assets.</li>
<li>Interest on investment in securities and deposits, rents and all monies received by the Board in any other manner or from and other source.</li>
<li>All monies forming part of the funds shall be kept in saving account or fixed deposit account with any nationalized bank. Such accounts shall be operated by such officers of the Board as may be authorized by the Board.Explanation for the purpose of this sub-clause, nationalized bank means a bank specified in column 2 of the first scheduled to the Banking companies (Acquisition and Transfer of Undertakings) Act, 1970 (5 of 1970) and also to the Banking Companies (Acquisition and Transfer of Undertakings) Act, 1980 (40 of 1980).
</li>
<li>The Board may, with the previous permission of the State Government borrow money from open market or otherwise with a view to provide itself with adequate resources.</li>
<li>The Board may, accept deposits on such conditions as it deems fit from persons, authorities or establishments with whom it has to transact any business.</li>
<li>The Board shall make provision for such reserve and other denominated funds as may be provided in this Scheme.</li>
<li>The Board shall have the authority to spend such sums as it thinks fit for the purpose authorized under this Scheme from and out of the general fund of the Board or from the reserve and other funds as the case may be.</li>
<li>The Board shall cause the proper account to be kept of the cost of operating this Scheme and all receipts and expenses under this Scheme.</li>
<li>The Board shall submit to the State Government.</li>
<li>As soon as may be, after the first day of April, in every year and not later than the 31st day of October, an annual report on the working of the Scheme during the preceding year ending the 31st of March, together with an audited balance-sheet; and copies of proceeding of the meeting of the Board.
</li>
<li>The Board may :-
<ul>
<li>Fix the number of Security Guards of the Board to be registered under the various categories.</li>
<li>Increase or decrease the number of registered Security Guards of the Board in any category on the register from time to time as may be necessary after a periodical review of the register and anticipated requirements.</li>
<li>Sanction the temporary registration of a specified number of Security Guards of the Board in any category for specific periods which shall not be more than 5% of the prescribed total registered Security Guards of the Board by following procedure of registration of Security Guards.</li>
<li>Device forms records registers, statements and the like required for administration of the Scheme.</li>
<li>Determine the wages, allowances and other conditions of service including age of retirement of all the pool.</li>
<li>Determine the manner of disbursement of wages and other allowances of all the Security Guards and the Security Guards of the employer agencies registered with the Board. The Payment of all Security Guards shall be made through cheque.</li>
<li>Fix the rate of levy under Clause 40.</li>
<li>Sanction the annual budget.</li>
<li>Subject to the provisions of clause 4, appoint a Secretary, the Personnel Officer and other staff of the Board.</li>
<li>Make recommendation to the State Government about any modification in the Scheme.</li>
<li>Settle disputes between registered principal employers and registered Security Guards of the Board.</li>
<li>Subject to such conditions as it thinks fit, delegate in writing to the Chairman, Secretary or to any other officer of the Board any of its functions under this Scheme to ensure that Employees State Insurance Scheme is made applicable to all the Security Guards.

</li>

</ul>
</li>

</ul>
</div>
    </div>
</div>
</div>
</section>

    </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
components: { PortalNavbar}
}
</script>

<style scoped>


.function_area .function_row {
padding-top:10px;
padding-bottom:10px;
  
}

.function_area .function_row ul {
  font: 400 14px/26px "Open sans", sans-serif;
  color: #555555;
	 padding-top: 18px;
  padding-bottom: 14px;
}

.subtittle h2 {
  font: 700 36px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h2:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 120px;
  background: #222222;
  left: 0;
  bottom: -22px;
}	


</style>



// WEBPACK FOOTER //
// src/components/Portal/Function.vue